import {useSelector} from "react-redux";
import moment from "moment";
import React, {useEffect, useState} from "react";
import associateServices from "../../services";
import {useTranslation} from "react-i18next";
import Loading from "../loading";
import './index.css'
import SvgIcon from "../svg-icon";
import {Tooltip} from "react-tooltip";
import RankIcon from "../rank-icon";
import {Link, useSearchParams} from "react-router-dom";
import {toast} from "react-toastify";
import InformationToast from "../toast/InformationToast";
import stringHelper from "../../helpers/string-helper";

const PublicUserProgress = props => {

    let {username} = props
    const {user, authenticated} = useSelector(state => state.authenticationReducer)

    const [stateUsername, setStateUsername] = useState('')
    const [searchParams, setSearchParams] = useSearchParams()

    const {t} = useTranslation()
    const [loading, setLoading] = useState(true)
    const [ignoring, setIgnoring] = useState(false)
    const [error, setError] = useState(false)

    const [data, setData] = useState({})

    useEffect(() => {
        setStateUsername(username ?? user?.username)
    }, [username, user?.username])

    useEffect(() => {
        if (stateUsername)
            getStats()
    }, [stateUsername])


    const getStats = () => {
        associateServices.getVipState({
            username: stateUsername
        }).then(res => {
            if (res?.status === 200) {
                setData(res?.data)
            } else {
                setError(res?.errors)
            }
            setLoading(false)
        })
    }
    const handleIgnore = () => {
        if (ignoring)
            return false

        data?.ignored ? unIgnoreUser(stateUsername) : ignoreUser(stateUsername)
    }

    const ignoreUser = username => {
        setIgnoring(true)
        associateServices.ignore({username}).then(res => {
            toast(<InformationToast
                icon={res?.status === 200 ? 'ti-check' : 'ti-x'}
                message={res?.status === 200 ? t(`api-notifications.${res?.data}`) : t(`api-notifications.${res?.errors}`)}
                title={res?.status === 200 ? t(`general.information`) : t(`general.error`)}
            />)
            setIgnoring(false)
            getStats()
        })
    }
    const unIgnoreUser = username => {
        setIgnoring(true)
        associateServices.unignore({username}).then(res => {

            toast(<InformationToast
                icon={res?.status === 200 ? 'ti-check' : 'ti-x'}
                message={res?.status === 200 ? t(`api-notifications.${res?.data}`) : t(`api-notifications.${res?.errors}`)}
                title={res?.status === 200 ? t(`general.information`) : t(`general.error`)}
            />)

            setIgnoring(false)
            getStats()
        })
    }

    return (
        loading ? <Loading/> :
            <div className="progress-wrapper">
                <div className="modal__profile">


                    {
                        error ? <span>{t(`api-notifications.${error}`)}</span> :
                            <div className="d-flex align-items-center gap-2">
                                {
                                    data?.ranki &&
                                    <div className="modal__icon">
                                        <Tooltip className="tooltip-me" anchorSelect={`#next-rank`}>
                                        <span className="xtable__coin gap-2">
                                            {/*<SvgIcon id={data?.rank}/>*/}
                                            {data?.rank}
                                            {/*{t(`modals.vip.progress.${data?.rank}`)}*/}
                                        </span>
                                        </Tooltip>

                                        <span id="next-rank" className="d-flex gap-2">
                                        <RankIcon icon={data?.ranki}/>
                                    </span>

                                    </div>
                                }
                                <div className="modal__user">
                                    <p>{data?.username}</p>
                                    <span>{moment.unix(data?.registration).format("MMM Do YY")}</span>
                                </div>
                            </div>
                    }


                    {
                        authenticated && !error &&
                        <div className="modal__profile-btns">
                            <Link
                                to={stringHelper.getModalPathWithTab('wallet', 'tip', searchParams)}
                                className="modal__btn-small modal__btn-small--green" type="button">
                                <SvgIcon id={'money-bag'}/>
                                {t('general.tip')}
                            </Link>
                            <button
                                disabled={ignoring}
                                onClick={handleIgnore} className="modal__btn-small modal__btn-small--red"
                                type="button">
                                <SvgIcon id={data?.ignored ? 'unlock' : 'lock'}/>
                                {data?.ignored ? t('general.unignore') : t('general.ignore')}
                            </button>
                        </div>
                    }

                </div>
            </div>
    )

}

export default PublicUserProgress
